import { staticGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import * as z from "zod";

export const createStaticSegment = {
  name: "createStaticSegment" as const,
  description:
    "Create an empty static (snapshot) audience. Add members afterward by importing or sampling from another segment. Check fetchTeamSegments first to reuse an existing audience instead of duplicating one.",
  mutates: true,
  input: z.object({ name: z.string() }),
  output: staticGroupSchema,
};
